/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddUserResponse,
  AddUserResponseV1,
  AllUserObjects,
  MergedUserAdminDelete,
  MergedUserDelete,
  MergedUserSelfUpdateSettings,
  MergedUserSelfUpdateSettingsV1,
  MiniOrganization,
  OrgUserAdminUpdate,
  OrgUserForClient,
  OrgUserOnAzure,
  OrgUserSelfCreateRequest,
  OrgUserSelfUpdate,
  OrgUserSelfUpdateV1,
  OrgUserUpdateEmergencyConfigRequest,
  OrgUserUpdateGroup,
  OrgUserUpdateOrganization,
  OrgUserUpdatePvdConfigRequest,
  OrgUserUpdateUnifiedConfigRequest,
  UpdateOrganizationResponse,
  UserCultureRequest,
  UserHistoryAddInboxMessagesRead,
  UserLocationTrackingPreferenceRequest,
} from '../models/index';
import {
    AddUserResponseFromJSON,
    AddUserResponseToJSON,
    AddUserResponseV1FromJSON,
    AddUserResponseV1ToJSON,
    AllUserObjectsFromJSON,
    AllUserObjectsToJSON,
    MergedUserAdminDeleteFromJSON,
    MergedUserAdminDeleteToJSON,
    MergedUserDeleteFromJSON,
    MergedUserDeleteToJSON,
    MergedUserSelfUpdateSettingsFromJSON,
    MergedUserSelfUpdateSettingsToJSON,
    MergedUserSelfUpdateSettingsV1FromJSON,
    MergedUserSelfUpdateSettingsV1ToJSON,
    MiniOrganizationFromJSON,
    MiniOrganizationToJSON,
    OrgUserAdminUpdateFromJSON,
    OrgUserAdminUpdateToJSON,
    OrgUserForClientFromJSON,
    OrgUserForClientToJSON,
    OrgUserOnAzureFromJSON,
    OrgUserOnAzureToJSON,
    OrgUserSelfCreateRequestFromJSON,
    OrgUserSelfCreateRequestToJSON,
    OrgUserSelfUpdateFromJSON,
    OrgUserSelfUpdateToJSON,
    OrgUserSelfUpdateV1FromJSON,
    OrgUserSelfUpdateV1ToJSON,
    OrgUserUpdateEmergencyConfigRequestFromJSON,
    OrgUserUpdateEmergencyConfigRequestToJSON,
    OrgUserUpdateGroupFromJSON,
    OrgUserUpdateGroupToJSON,
    OrgUserUpdateOrganizationFromJSON,
    OrgUserUpdateOrganizationToJSON,
    OrgUserUpdatePvdConfigRequestFromJSON,
    OrgUserUpdatePvdConfigRequestToJSON,
    OrgUserUpdateUnifiedConfigRequestFromJSON,
    OrgUserUpdateUnifiedConfigRequestToJSON,
    UpdateOrganizationResponseFromJSON,
    UpdateOrganizationResponseToJSON,
    UserCultureRequestFromJSON,
    UserCultureRequestToJSON,
    UserHistoryAddInboxMessagesReadFromJSON,
    UserHistoryAddInboxMessagesReadToJSON,
    UserLocationTrackingPreferenceRequestFromJSON,
    UserLocationTrackingPreferenceRequestToJSON,
} from '../models/index';

export interface ApiOrgUserAddInboxMessageReadPutRequest {
    userHistoryAddInboxMessagesRead?: UserHistoryAddInboxMessagesRead;
}

export interface ApiOrgUserAddPostRequest {
    orgUserSelfCreateRequest?: OrgUserSelfCreateRequest;
}

export interface ApiOrgUserAddV1PostRequest {
    orgUserSelfCreateRequest?: OrgUserSelfCreateRequest;
}

export interface ApiOrgUserDeleteDeleteRequest {
    mergedUserDelete?: MergedUserDelete;
}

export interface ApiOrgUserDeleteViaAdminDeleteRequest {
    mergedUserAdminDelete?: MergedUserAdminDelete;
}

export interface ApiOrgUserUpdateEmergencyConfigPutRequest {
    orgUserUpdateEmergencyConfigRequest?: OrgUserUpdateEmergencyConfigRequest;
}

export interface ApiOrgUserUpdateGroupPutRequest {
    orgUserUpdateGroup?: OrgUserUpdateGroup;
}

export interface ApiOrgUserUpdateGroupV1PutRequest {
    orgUserUpdateGroup?: OrgUserUpdateGroup;
}

export interface ApiOrgUserUpdateLanguageCodePostRequest {
    userCultureRequest?: UserCultureRequest;
}

export interface ApiOrgUserUpdateLocationTrackingPreferencePostRequest {
    userLocationTrackingPreferenceRequest?: UserLocationTrackingPreferenceRequest;
}

export interface ApiOrgUserUpdateOrganizationPutRequest {
    orgUserUpdateOrganization?: OrgUserUpdateOrganization;
}

export interface ApiOrgUserUpdateOrganizationV1PutRequest {
    orgUserUpdateOrganization?: OrgUserUpdateOrganization;
}

export interface ApiOrgUserUpdatePvdConfigPutRequest {
    orgUserUpdatePvdConfigRequest?: OrgUserUpdatePvdConfigRequest;
}

export interface ApiOrgUserUpdateSettingsViaSelfPutRequest {
    mergedUserSelfUpdateSettings?: MergedUserSelfUpdateSettings;
}

export interface ApiOrgUserUpdateSettingsViaSelfV1PutRequest {
    mergedUserSelfUpdateSettingsV1?: MergedUserSelfUpdateSettingsV1;
}

export interface ApiOrgUserUpdateUnifiedConfigPutRequest {
    orgUserUpdateUnifiedConfigRequest?: OrgUserUpdateUnifiedConfigRequest;
}

export interface ApiOrgUserUpdateViaAdminPutRequest {
    orgUserAdminUpdate?: OrgUserAdminUpdate;
}

export interface ApiOrgUserUpdateViaSelfPutRequest {
    orgUserSelfUpdate?: OrgUserSelfUpdate;
}

export interface ApiOrgUserUpdateViaSelfV1PutRequest {
    orgUserSelfUpdateV1?: OrgUserSelfUpdateV1;
}

/**
 * 
 */
export class OrgUserApi extends runtime.BaseAPI {

    /**
     */
    async apiOrgUserAddInboxMessageReadPutRaw(requestParameters: ApiOrgUserAddInboxMessageReadPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/AddInboxMessageRead`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserHistoryAddInboxMessagesReadToJSON(requestParameters['userHistoryAddInboxMessagesRead']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgUserAddInboxMessageReadPut(requestParameters: ApiOrgUserAddInboxMessageReadPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgUserAddInboxMessageReadPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgUserAddPostRaw(requestParameters: ApiOrgUserAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddUserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserSelfCreateRequestToJSON(requestParameters['orgUserSelfCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserAddPost(requestParameters: ApiOrgUserAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddUserResponse> {
        const response = await this.apiOrgUserAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserAddV1PostRaw(requestParameters: ApiOrgUserAddV1PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddUserResponseV1>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/Add_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserSelfCreateRequestToJSON(requestParameters['orgUserSelfCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddUserResponseV1FromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserAddV1Post(requestParameters: ApiOrgUserAddV1PostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddUserResponseV1> {
        const response = await this.apiOrgUserAddV1PostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserDeleteDeleteRaw(requestParameters: ApiOrgUserDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: MergedUserDeleteToJSON(requestParameters['mergedUserDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgUserDeleteDelete(requestParameters: ApiOrgUserDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgUserDeleteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgUserDeleteViaAdminDeleteRaw(requestParameters: ApiOrgUserDeleteViaAdminDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/DeleteViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: MergedUserAdminDeleteToJSON(requestParameters['mergedUserAdminDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgUserDeleteViaAdminDelete(requestParameters: ApiOrgUserDeleteViaAdminDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgUserDeleteViaAdminDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgUserGetIfIExistGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/GetIfIExist`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiOrgUserGetIfIExistGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiOrgUserGetIfIExistGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserGetSelfV1GetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllUserObjects>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/GetSelf_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllUserObjectsFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserGetSelfV1Get(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllUserObjects> {
        const response = await this.apiOrgUserGetSelfV1GetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateEmergencyConfigPutRaw(requestParameters: ApiOrgUserUpdateEmergencyConfigPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgUserOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateEmergencyConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserUpdateEmergencyConfigRequestToJSON(requestParameters['orgUserUpdateEmergencyConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgUserOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateEmergencyConfigPut(requestParameters: ApiOrgUserUpdateEmergencyConfigPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgUserOnAzure> {
        const response = await this.apiOrgUserUpdateEmergencyConfigPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateGroupPutRaw(requestParameters: ApiOrgUserUpdateGroupPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateGroup`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserUpdateGroupToJSON(requestParameters['orgUserUpdateGroup']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgUserUpdateGroupPut(requestParameters: ApiOrgUserUpdateGroupPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgUserUpdateGroupPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgUserUpdateGroupV1PutRaw(requestParameters: ApiOrgUserUpdateGroupV1PutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MiniOrganization>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateGroup_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserUpdateGroupToJSON(requestParameters['orgUserUpdateGroup']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MiniOrganizationFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateGroupV1Put(requestParameters: ApiOrgUserUpdateGroupV1PutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MiniOrganization> {
        const response = await this.apiOrgUserUpdateGroupV1PutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateLanguageCodePostRaw(requestParameters: ApiOrgUserUpdateLanguageCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgUserOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateLanguageCode`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCultureRequestToJSON(requestParameters['userCultureRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgUserOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateLanguageCodePost(requestParameters: ApiOrgUserUpdateLanguageCodePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgUserOnAzure> {
        const response = await this.apiOrgUserUpdateLanguageCodePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateLocationTrackingPreferencePostRaw(requestParameters: ApiOrgUserUpdateLocationTrackingPreferencePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgUserOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateLocationTrackingPreference`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserLocationTrackingPreferenceRequestToJSON(requestParameters['userLocationTrackingPreferenceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgUserOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateLocationTrackingPreferencePost(requestParameters: ApiOrgUserUpdateLocationTrackingPreferencePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgUserOnAzure> {
        const response = await this.apiOrgUserUpdateLocationTrackingPreferencePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateOrganizationPutRaw(requestParameters: ApiOrgUserUpdateOrganizationPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateOrganizationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateOrganization`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserUpdateOrganizationToJSON(requestParameters['orgUserUpdateOrganization']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateOrganizationResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateOrganizationPut(requestParameters: ApiOrgUserUpdateOrganizationPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateOrganizationResponse> {
        const response = await this.apiOrgUserUpdateOrganizationPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateOrganizationV1PutRaw(requestParameters: ApiOrgUserUpdateOrganizationV1PutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateOrganizationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateOrganization_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserUpdateOrganizationToJSON(requestParameters['orgUserUpdateOrganization']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateOrganizationResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateOrganizationV1Put(requestParameters: ApiOrgUserUpdateOrganizationV1PutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateOrganizationResponse> {
        const response = await this.apiOrgUserUpdateOrganizationV1PutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdatePvdConfigPutRaw(requestParameters: ApiOrgUserUpdatePvdConfigPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgUserOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdatePvdConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserUpdatePvdConfigRequestToJSON(requestParameters['orgUserUpdatePvdConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgUserOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdatePvdConfigPut(requestParameters: ApiOrgUserUpdatePvdConfigPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgUserOnAzure> {
        const response = await this.apiOrgUserUpdatePvdConfigPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateSettingsViaSelfPutRaw(requestParameters: ApiOrgUserUpdateSettingsViaSelfPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateSettingsViaSelf`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MergedUserSelfUpdateSettingsToJSON(requestParameters['mergedUserSelfUpdateSettings']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgUserUpdateSettingsViaSelfPut(requestParameters: ApiOrgUserUpdateSettingsViaSelfPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgUserUpdateSettingsViaSelfPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgUserUpdateSettingsViaSelfV1PutRaw(requestParameters: ApiOrgUserUpdateSettingsViaSelfV1PutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllUserObjects>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateSettingsViaSelf_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MergedUserSelfUpdateSettingsV1ToJSON(requestParameters['mergedUserSelfUpdateSettingsV1']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllUserObjectsFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateSettingsViaSelfV1Put(requestParameters: ApiOrgUserUpdateSettingsViaSelfV1PutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllUserObjects> {
        const response = await this.apiOrgUserUpdateSettingsViaSelfV1PutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateUnifiedConfigPutRaw(requestParameters: ApiOrgUserUpdateUnifiedConfigPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgUserOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateUnifiedConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserUpdateUnifiedConfigRequestToJSON(requestParameters['orgUserUpdateUnifiedConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgUserOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateUnifiedConfigPut(requestParameters: ApiOrgUserUpdateUnifiedConfigPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgUserOnAzure> {
        const response = await this.apiOrgUserUpdateUnifiedConfigPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgUserUpdateViaAdminPutRaw(requestParameters: ApiOrgUserUpdateViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserAdminUpdateToJSON(requestParameters['orgUserAdminUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgUserUpdateViaAdminPut(requestParameters: ApiOrgUserUpdateViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgUserUpdateViaAdminPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgUserUpdateViaSelfPutRaw(requestParameters: ApiOrgUserUpdateViaSelfPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateViaSelf`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserSelfUpdateToJSON(requestParameters['orgUserSelfUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgUserUpdateViaSelfPut(requestParameters: ApiOrgUserUpdateViaSelfPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgUserUpdateViaSelfPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgUserUpdateViaSelfV1PutRaw(requestParameters: ApiOrgUserUpdateViaSelfV1PutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgUserForClient>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgUser/UpdateViaSelf_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgUserSelfUpdateV1ToJSON(requestParameters['orgUserSelfUpdateV1']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgUserForClientFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgUserUpdateViaSelfV1Put(requestParameters: ApiOrgUserUpdateViaSelfV1PutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgUserForClient> {
        const response = await this.apiOrgUserUpdateViaSelfV1PutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
